export default "__VITE_ASSET__nI$0eF3P__"